import { useBaseFilterSearchParams } from '@/src/hooks/searchParams/useBaseFilterSearchParams';
import { SortOrder } from '@/src/util/filters';

import { View } from './types';

export const useLibrarySearchParams = () => {
  const { searchParams, currentSearchParams, parsedFilter, setParams, clearSearchParams } =
    useBaseFilterSearchParams();

  return {
    view: searchParams.get('view') as View,
    filter: parsedFilter,
    isTrash: searchParams.get('view') === View.Trash,
    sort: searchParams.get('sort'),
    order: searchParams.get('order') as SortOrder,
    searchParams: currentSearchParams,
    setParams,
    clearSearchParams,
  };
};
